import type { Schedules } from "./types";

/**
 * SIM-3044: drop every schedule entry naming `tableName`, or null if none did.
 * Matched case-insensitively like the runner's `applySchedule()`, so an entry
 * whose casing drifted from the table's is cleaned up rather than stranded.
 */
export function pruneSchedulesForTable(schedules: Schedules, tableName: string): Schedules | null {
  const target = tableName.trim().toLowerCase();
  if (!target) return null;
  let changed = false;
  const next: Schedules = {};
  for (const [cadence, entries] of Object.entries(schedules)) {
    const list = entries ?? [];
    const kept = list.filter((e) => String(e.name ?? "").toLowerCase() !== target);
    if (kept.length !== list.length) changed = true;
    next[cadence] = kept;
  }
  return changed ? next : null;
}
